// app/javascript/entrypoints/application.js

// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

const application = Application.start()

// Register all controllers from controllers/**/*_controller.js
const controllers = import.meta.glob("../controllers/**/*_controller.js", { eager: true })
const myControllers = import.meta.glob("../my_controllers/**/*_controller.js", { eager: true })

registerControllers(application, controllers)
registerControllers(application, myControllers)

// Configure Stimulus development experience
if (import.meta.env.DEV) {
	application.debug = true
	window.Stimulus = application
}

// Import existing polyfills
import "formdata-polyfill"